export default "__VITE_ASSET__1kZ0_zT7__"